import { useTheme } from "../../../CommonComponents/ThemeProvider";
import React from "react";
import { formatPrice } from "../../utils/FormatPrice";

/**
 * QuickCashButtons
 * - Renders a set of quick cash buttons
 * - Calls onSelect with the value when a button is clicked
 */
export default function QuickCashButtons({ values, onSelect }) {
    const { currentTheme } = useTheme();
    return (
        <div className="flex w-full flex-wrap gap-1.5">
            {values.map((item) => {
                const value = typeof item === "object" ? item.value : item;
                const label = typeof item === "object" ? item.label : formatPrice(item);
                const tooltip = typeof item === "object"
                    ? item.tooltip || `Use ${formatPrice(value)} for quick cash`
                    : `Add ${formatPrice(value)} for quick cash`;

                return (
                <div key={`${label}-${value}`} className="relative group flex min-w-[70px] flex-1">
                    <button
                        type="button"
                        onClick={() => onSelect(value)}
                        className="h-8 w-full min-w-0 rounded-full border border-slate-200 bg-white px-2 text-xs font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50 active:bg-slate-100 focus:outline-none"
                        style={{
                            boxShadow: undefined,
                            borderColor: undefined,
                            outline: undefined,
                            outlineColor: undefined,
                        }}
                        // Use inline style for focus ring color
                        onFocus={e => e.target.style.boxShadow = `0 0 0 2px ${currentTheme.color}`}
                        onBlur={e => e.target.style.boxShadow = ''}
                    >
                        {label}
                    </button>
                    <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-max px-2 py-1 rounded bg-black text-white text-xs opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-10 whitespace-nowrap">
                        {tooltip}
                    </span>
                </div>
                );
            })}
        </div>
    );
}
